"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonRegistrationRightsHolder = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const user_statuses_1 = require("@Const/user-statuses");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const ButtonRegistrationRightsHolder = (props) => {
    const { userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [notVerifiedPopupIsOpen, setNotVerifiedPopupIsOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        userStore.userInfo && userStore.userInfo.verificationStatus === user_statuses_1.USER_VERIFICATION_STATUSES.VERIFIED ? (react_1.default.createElement(Button_1.Button, { mainColor: props.mainColor, type: 'primary', icon: common_1.ICONS.add, typeLink: true, linkTo: navigation_1.default.registrationRightsholder.form() }, "Create a Member")) : (react_1.default.createElement(Button_1.Button, { mainColor: props.mainColor, type: 'primary', icon: common_1.ICONS.add, onClick: () => setNotVerifiedPopupIsOpen(true) }, "Create a Member")),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: notVerifiedPopupIsOpen, onClose: () => setNotVerifiedPopupIsOpen(false) },
            react_1.default.createElement(Popup_1.default, { onClose: () => setNotVerifiedPopupIsOpen(false) },
                react_1.default.createElement("div", { className: 'not-verified-popup-content' },
                    react_1.default.createElement("h4", null, "You must be verified before you can register a Member"),
                    react_1.default.createElement("p", null,
                        "Please fill out all User Information in your Profile and click the \"Get Verified\" link. Need help? ",
                        react_1.default.createElement("a", { href: navigation_1.default.contactUs.root() }, "Contact Support"),
                        "."),
                    react_1.default.createElement("div", { className: 'buttons-block' },
                        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: () => setNotVerifiedPopupIsOpen(false) }, "Cancel"),
                        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', typeLink: true, linkTo: navigation_1.default.profile.user() }, "Get Verified")))))));
};
exports.ButtonRegistrationRightsHolder = ButtonRegistrationRightsHolder;
